import { render, staticRenderFns } from "./BaseLabelsMenu.vue?vue&type=template&id=6d22e4f6"
import script from "./BaseLabelsMenu.vue?vue&type=script&lang=js"
export * from "./BaseLabelsMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseLabelsMenu.vue?vue&type=style&index=0&id=6d22e4f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports